/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {ping} from '../api'

export const useMutationPing = createReactQueryMutationHook('ping', ping)
